import { render } from "./CheckoutGetStartedNow.vue?vue&type=template&id=6be9fd47"
import script from "./CheckoutGetStartedNow.vue?vue&type=script&lang=js"
export * from "./CheckoutGetStartedNow.vue?vue&type=script&lang=js"

import "./CheckoutGetStartedNow.vue?vue&type=style&index=0&id=6be9fd47&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__